import debugFactory from "debug";

const IS_DEV_ENV = process.env.NODE_ENV === "development";

const debug = debugFactory( "teaming:common-vendor:intercom" );

/* eslint-disable new-cap */
const safeIntercom = ( ...args ) => {
	if ( window.Intercom ) {
		window.Intercom( ...args );
	}
	if ( IS_DEV_ENV ) {
		debug( ...args ); // eslint-disable-line no-console
	}
};

let instance = null;

export default function() {
	if ( instance ) {
		return instance;
	}

	let cachedAttributes = {};

	instance = {
		/**
		 * @see https://developers.intercom.com/installing-intercom/docs/intercom-javascript#section-intercomupdate
		 * @see https://developers.intercom.com/installing-intercom/docs/javascript-api-attributes-objects#section-data-attributes
		 */
		async update( user, customAttributes = {} ) {
			if ( !user ) {
				// cache attributes until a user is actually provided --
				// not crazy about this but we can't guarantee that the
				// user object is loaded before these attributes start
				// arriving, so we need to wait to send them until
				// the user object actually DOES get loaded
				Object.assign( cachedAttributes, customAttributes );
				return;
			}

			/* eslint-disable camelcase */
			const userData = Object.assign( {
				email: user.email,
				name: user.name,
				avatar: {
					type: "avatar",
					image_url: user.picture,
				},
				user_hash: user.intercomUserHash,
				source: user.source,
			}, cachedAttributes, customAttributes );
			/* eslint-enable camelcase */

			safeIntercom( "update", userData );

			cachedAttributes = {};
		},
		trackEvent( eventName, metdata ) {
			safeIntercom( "trackEvent", eventName, metdata );
		},
		shutdown() {
			safeIntercom( "shutdown" );
		},
		//
		// event API
		//
		userCancellationRequest( personId, reasons = [], comments = "" ) {
			/* eslint-disable camelcase */
			return this.trackEvent( "User Cancellation Request", {
				person_id: personId,
				reasons: reasons.map( reason => `${ reason }`.trim() ).join( "," ),
				comments,
			} );
			/* eslint-enable camelcase */
		},
		show() {
			safeIntercom( "show" );
		},
		hide() {
			safeIntercom( "hide" );
		},
	};

	return instance;
}
/* eslint-enable new-cap */
